import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import logo from '../assets/RGB_IFP_Short_Rich Black.png';

const Nav = styled.nav`
  background-color: #fff;
  width: 100%;
  z-index: 1000;
  box-shadow: none;
  border-bottom: 1px solid #373737;
  position: sticky;
  top: 0;
  margin: 0;
  padding: 0;
  
  @media (max-width: 768px) {
    padding: 0;
    margin-bottom: 0;
  }
`;

const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 90%;
  margin: 0 auto;
  padding: ${props => props.isMobile ? '16px 16px' : '16px 24px'};
  
  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  width: 103px;
  
  img {
    height: auto;
    max-height: 60px;
    width: auto;
    max-width: 100%;
    object-fit: contain;
    @media (max-width: 768px) {
      max-height: 30px;
      width: 75px;
    }
  }
`;

const NavLinks = styled.div`
  display: flex;
  gap: 20px;
  

  a {
    font-family: var(--font-soehne);
    font-weight: 300;
    color: #4b5563;
    text-decoration: none;
    padding: 3px 10px;
    transition: opacity 0.3s ease;
    
    @media (max-width: 768px) {
      font-size: 0.9rem;
      padding: 3px 8px;
    }
    
    &:hover {
      opacity: 0.8;
    }
    
    &.active {
      font-weight: 500;
      border-bottom: 1px solid #4b5563;
    }
  }
`;

const Navbar = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return (
    <Nav>
      <NavContainer isMobile={isMobile}>
        <div style={{ 
          display: 'flex', 
          alignItems: 'center',
          flexDirection: 'row',
        }}>
          <Logo>
            <a href="https://www.ifp.org" target="_blank" rel="noopener noreferrer">
              <img src={logo} alt="IFP Logo" />
            </a>
          </Logo>
        </div>
        <NavLinks>
          <Link to="/" className={isHome ? 'active' : ''}>
            Home
          </Link>
          <Link to="/methodology" className={location.pathname === '/methodology' ? 'active' : ''}>
            Methodology
          </Link>
        </NavLinks>
      </NavContainer>
    </Nav>
  );
};

export default Navbar; 